var site = site || {};
site.inits = [];
site.inits.push("site.search.init()");

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.search = {
	init: function() {
		$('.searchBtn').click(function() {
			$this = $(this);
			if($this.hasClass('open')) {
				$this.toggleClass('open');
				$('#searchBox').css('maxHeight',0);

				setTimeout( function() {
						$('#searchBox').removeClass('open').removeAttr('style');
				}, 600);
			}
			else {
				$this.toggleClass('open');
				$('#searchBox').toggleClass('open');
			}
		});
	}
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.translate = {
	init: function () {
		function waitForElm(selector) {
			return new Promise(resolve => {
				if (document.querySelector(selector)) {
					return resolve(document.querySelector(selector));
				}

				const observer = new MutationObserver(mutations => {
					if (document.querySelector(selector)) {
						resolve(document.querySelector(selector));
						observer.disconnect();
					}
				});

				observer.observe(document.body, {
					childList: true,
					subtree: true
				});
			});
		}
		waitForElm('.skiptranslate iframe').then(elm => {
			document.body.classList.add('translateOpen');
			let parent = elm.parentNode;
			let observer = new MutationObserver(function(mutationsList, observer) {
				for (var mutation of mutationsList){
					if (mutation.attributeName === 'style') {
						if (parent.style.display === 'none') {
							document.body.classList.remove('translateOpen');
						}
						else {
							document.body.classList.add('translateOpen');
						}
					}
				}
			});
			observer.observe(elm.parentNode, { attributes: true});
		})
	}
}

site.coursesMixitup = {
	init: function () {
		var targetSelector = '.course';

		/**
		 * Reads a hash from the URL (if present), and converts it into a class
		 * selector string. E.g "#green" -> ".green". Otherwise, defaults
		 * to the targetSelector, equivalent to "all"
		 *
		 * @return {string}
		 */
		function getSelectorFromHash() {
			var hash = window.location.hash.replace(/^#/g, '');

			var selector = hash ? '.' + hash : targetSelector;

			return selector;
		}

		/**
		 * Updates the URL whenever the current filter changes.
		 *
		 * @param   {mixitup.State} state
		 * @return  {void}
		 */
		function setHash(state) {
			var selector = state.activeFilter.selector;
			var newHash = '#' + selector.replace(/^./g, '');

			if (selector === targetSelector && window.location.hash) {
				// Equivalent to filter "all", remove the hash

				history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
			} else if (newHash !== window.location.hash && selector !== targetSelector) {
				// Change the hash

				history.pushState(null, document.title, window.location.pathname + newHash); // or history.replaceState()
			}
		}

		// Instantiate and configure the mixer
		var mixer = mixitup('.coursesContainer', {
			selectors: {
				target: targetSelector
			},
			animation: {
				enable: false
			},
			load: {
				filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
			},
			callbacks: {
				onMixEnd: setHash // Call the setHash() method at the end of each operation
			}
		});

		window.onhashchange = function () {
			var selector = getSelectorFromHash();
			if (selector === mixer.getState().activeFilter.selector) return; // no change

			mixer.filter(selector);
		};
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.translate.init();

	site.owl.init("#hero ul", {
		items: 1,
		dotsSpeed: 1000,
		loop: true,
		dots: true
	});

	site.owl.init("#reviews ul", {
		items: 1,
		dotsSpeed: 1000,
		nav: true,
		navText: ['<div class="rect side"></div>', '<div class="rect side reverse"></div>'],
		dots: true
	});

	site.owl.init(".frontEvents .eventList", {
		items: 4,
		dots: true,
		margin: 30,
		responsive: {
			1 : {
				items : 1
			},
			480 : {
				items : 2
			},
			800 : {
				items : 3
			},
			1080 : {
				items : 4
			}
		}
	});

	site.owl.init("#myschool .carousel", {
		items: 1,
		loop: true,
		nav: true,
		navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
	});

	$("#hero .owl-dots").wrap("<div class='center owlDotsCenter' ></div>");
	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	let $body = $('body');
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	if ($('.coursesContainer').length) {
		site.coursesMixitup.init();
	}

	if($body.is('.courseView')) {
		site.owl.init('.courseView .carousel', {
			items: 1,
			loop: true,
			nav: true,
			navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
		});
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
